<template>
  <div class="mt-24 md:text-center md:items-center flex flex-col">
    <h2 class="text-left uppercase px-8 md:px-8 text-4xl">Уважаемый гость!</h2>
    <div class="tracking-widest max-w-6xl">
      <p>
        Рады сообщить, что для Вас действует специальное предложение — услуга
        <span class="text-white">«Консьерж-сервис».</span>
      </p>
      <p>
        Воспользоваться услугой могут держатели
        <span class="text-white">карт «Деловой проездной» поездов “Сапсан”, </span> а также гости
        <span class="text-white">первого и бизнес-классов.</span>
      </p>
      <p>После оформления заявки Вы можете обратиться в консьерж-сервис по любому из перечисленных ниже вопросов:</p>
    </div>
    <div class="fon">
      <Contacts class="hidden md:block" />
      <div class="help-services">
        <div class="help-item">
          <p>
            Возможность оформления проездных документов посредством <br />
            дистанционных каналов связи
          </p>
        </div>

        <div class="help-item reverse">
          <p>Помощь в любом вопросе во время путешествия</p>
        </div>

        <div class="help-item">
          <p>Возврат проездных документов при помощи специалиста Консьерж- Сервиса</p>
        </div>

        <div class="help-item reverse">
          <p>Помощь в оформлении услуги провоза домашнего животного</p>
        </div>

        <div class="help-item">
          <p>Помощь в выборе предоплаченного питания</p>
        </div>

        <div class="help-item reverse">
          <p>
            Оперативные консультации по услугам Дирекции скоростного <br />
            сообщения ОАО «РЖД»
          </p>
        </div>
      </div>
      <Contacts class="md:hidden" />
    </div>
  </div>
  <Digest />
</template>
<script>
import Contacts from '@/components/Contacts.vue'
import Digest from '@/components/Digest.vue'

export default {
  components: {
    Contacts,
    Digest,
  },
}
</script>
<style scoped>
.fon {
  background-image: url('../../assets/images/gray-fon.png');
  background-position: top;
  background-position-y: 55px;
  background-repeat: no-repeat;
  background-size: auto;
}
a {
  background: linear-gradient(180deg, #fff 0%, #787878 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
p {
  margin-top: 2rem;
  padding: 0 2rem;
  font-size: 18px;
}
.help-services {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin: 50px 2rem;
  text-align: left;
}
.help-item {
  display: flex;
  align-items: center;

  border: 2px solid transparent;
  border-image-slice: 1;
  border-image-source: linear-gradient(90deg, #1f1e1e 0%, #78787873 100%);
}

.help-item.reverse {
  border-image-source: linear-gradient(90deg, #7878786e 0%, #1f1e1e 100%);
}
.help-item > p {
  font-size: 16px;
  margin: 0;
  padding: 20px;
}

@media (max-width: 768px) {
  p {
    font-size: 20px;
    padding: 0 2rem;
  }
  .help-services {
    display: flex;
    flex-direction: column;
    margin: 35px 2rem;
  }
}
</style>
